import { FC_NODE_PROPERTIES } from "src/constants/CommonConstants";

export const getSelectedOption = (container, key) => {

    if(Object.keys(container).length === 0 && key) {
        return {label: key, id: key};
    } else if(!key && Object.keys(container).length === 0) {
        return;
    }
    const selectedKey = container.filter( r => {
        if(r.id === key) {
            return r;
        }
    })
    return selectedKey[0];
}

export const getSelectedOptions = (container, keys) => {
    if(Object.keys(container).length === 0 || typeof keys == "undefined"|| keys.length === 0) {
        return;
    }
    const selectedKeys = []   
    container.filter( r => {
        if(keys.includes(r.value)) {
            selectedKeys.push(r);
        }
    })

    return selectedKeys;
}

export const isMultiSelectIncludes = (multiselect, option) => {
    return `${multiselect.map(option => option.value).join(',')}`.includes(option);
}

export const getSelectedOptionsForMultiSelectFromString = (container, value) => {

    if(value) {
        const multiValues = value.split(',')
        return getSelectedOptions(container, multiValues);
    }
    return;
}

export const getAttributes = (attributeMap, values) => {
    let defaultNodeAttributes = {};
    for (const value of Object.keys(attributeMap)) {
        defaultNodeAttributes[value] = values[value] || undefined;
    }
    return defaultNodeAttributes;
}

export const getAttributesList = (attributeMap) => {
    let attributesList = [];
    for (const value of Object.keys(attributeMap)) {
        attributesList.push(value);
    }
    return attributesList;
}

export const getLabelForSelect = (attribute, lableValues) => {
    if(attribute === undefined) {
        return;
    }
    return lableValues.find(si => si.id === attribute)?.label
}

export const getLabelAndValue = (attribute) => {
    let options = []
    for (var i = 0; i < attribute.length; i++) 
    { 
        var dict = {};
        dict["label"] = attribute[i];
        dict["id"] = attribute[i];
        options.push(dict);
    }
    return options
}

export const getAnvilOptions = (attribute) => {
    let options = [];

    if(attribute) {
        const anvilList = attribute.split(',')
        anvilList.forEach( anvil => {
            options.push( {
                id: anvil.split('#')[0],
                label: anvil.replace('#', ' - ')
            }
            )
        })
    }
    return options;
}

export const getSelectOptionsFromString = (attribute) => {
    if( attribute) {
        let options = [];
        const optionList = attribute.split(',')
        optionList.forEach( option => {
            options.push( {
                id: option,
                label: option
            })
        })
        return options;
    } else {
        return [];
    }
}

export const getEntityProperties = (entityProperties) => {
    if(!entityProperties || entityProperties == "[]") {
        return "";
    }
    entityProperties = entityProperties.slice(1,-1).split(', ');

    let entityProperty = '';
    entityProperties.forEach(property => {
        entityProperty += `${FC_NODE_PROPERTIES[property]},  `
    });
    return entityProperty.replace(/,(?=[^,]*$)/, '');
}

export const getPipelineEntityPropertyFilterOptions = (pipelines, key) => {
    let options = [];

    pipelines.forEach( pipeline => {
        options.push({
            propertyKey: key,
            value: pipeline
        });
    })
    return options
}

export const getOptionsForSelect = (options) => {
    let selectOptions = []

    if(options) {
        options.forEach(element => {
            selectOptions.push({ label: element, id: element})
        });
    }
    return selectOptions;
}

export const fetchSupportedTimezones = (options) => {
    let supportedTimeZones = []

    if(options) {
        options.forEach(element => {
            supportedTimeZones.push(element.timezone)
        });
    }

    return supportedTimeZones;
}

export const isOfSameWorkflow = (attributes) => {
    const workflowTypes = attributes.map(attribute => attribute.WorkflowType)
    return workflowTypes.every((val, ind, arr) => val === arr[0]);
}
